import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  ClearEntityState,
  DocumentState,
  DocumentStateHelpers,
  EntityUpdateStrategy,
  IDocumentState,
} from '../../../core/state';
import { ReferralsPortalConnectionRepo } from '../connection/connection.repository';
import {
  LoadReferralsLastImport,
  ReferralsImportGoogleDelete,
  ReferralsImportLinkedinDelete,
} from './import.actions';
import { ReferralsImportSource, ReferralsLastImport } from './import.interfaces';
import { ReferralsImportHttpService } from './import.service';

export type IReferralsLastImportState = IDocumentState<ReferralsLastImport[]>;

@State({
  name: 'referralPortalLastImport',
  defaults: DocumentStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsLastImportRepo extends DocumentState<ReferralsLastImport[]>() {
  constructor(private importService: ReferralsImportHttpService) {
    super(EntityUpdateStrategy.replace);
  }

  @Action(LoadReferralsLastImport)
  public loadReferralsLastImport(
    ctx: StateContext<IReferralsLastImportState>,
    action: LoadReferralsLastImport,
  ): Observable<any> {
    this.markAsLoading(ctx);
    return this.importService
      .loadLatestImport()
      .pipe(tap(imports => this.save(ctx, action, imports)));
  }

  @Action(ReferralsImportLinkedinDelete)
  public referralsImportLinkedinDelete(
    ctx: StateContext<IReferralsLastImportState>,
  ): Observable<any> {
    return this.deleteImport(ctx, ReferralsImportSource.LinkedIn);
  }

  @Action(ReferralsImportGoogleDelete)
  public referralsImportGoogleDelete(
    ctx: StateContext<IReferralsLastImportState>,
  ): Observable<any> {
    return this.deleteImport(ctx, ReferralsImportSource.Google);
  }

  private deleteImport(
    ctx: StateContext<IReferralsLastImportState>,
    source: ReferralsImportSource,
  ): Observable<void> {
    return this.importService.deleteImport(source).pipe(
      tap(() => {
        ctx.dispatch(new ClearEntityState(ReferralsPortalConnectionRepo));
        ctx.dispatch(new LoadReferralsLastImport());
      }),
    );
  }
}
